export type MicroFrontendAvailableApps =
    | 'apptemplate-mf-example'
    | 'module-mf-playground'
    | 'sourcing-project-mf-decline-freelancer'
    | 'messenger-mf-chatbox'
    | 'project-admin-mf-project-admin'
    | 'punchout-mf-quote-admin'
    | 'vms-bridge-mf-quote-admin'
    | 'fees-mf-admin'
    | 'compliance-mf-business-settings'
    | 'compliance-mf-billing-information'
    | 'project-payment-mf-payment-admin'
    | 'search-mf-freelancers-catalogs'
    | 'project-proposal-mf-top-summaries'
    | 'search-mf-entrypoint'
    | 'financing-mf-financing-settings'
    | 'financing-mf-invoice-financing-admin'
    | 'payment-mf-freelancer-bank-account'
    | 'payment-mf-client-legal-entity-wallets'
    | 'brief-mf-details'
    | 'brief-mf-application-form'
    | 'brief-mf-edit'
    | 'compliance-mf-legal-name-autocomplete'
    | 'compliance-mf-misclassification-guidelines'
    | 'sourcing-project-mf-projects-history'
    | 'erp-accounting-mf-lot-entries'
    | 'compliance-mf-additional-billing-profile'
    | 'compliance-mf-client-identity-manual-verif'
    | 'search-mf-sourcing-search'
    | 'repatriation-opportunity-mf-brief'
    | 'compliance-mf-team-legal-entities';
// MF_APPS ⚓ DON'T TOUCH

export const MicroFrontendEndpointMapper: Record<MicroFrontendAvailableApps, `/${string}`> = {
    'apptemplate-mf-example': '/apptemplate-mf-example',
    'module-mf-playground': '/module-mf-playground',
    'sourcing-project-mf-decline-freelancer': '/sourcing-project-mf-decline-freelancer',
    'messenger-mf-chatbox': '/messenger-mf-chatbox',
    'punchout-mf-quote-admin': '/punchout-mf-quote-admin',
    'vms-bridge-mf-quote-admin': '/vms-bridge-mf-quote-admin',
    'compliance-mf-business-settings': '/compliance-mf-business-settings',
    'fees-mf-admin': '/fees-mf-admin',
    'compliance-mf-billing-information': '/compliance-mf-billing-information',
    'project-payment-mf-payment-admin': '/project-payment-mf-payment-admin',
    'search-mf-freelancers-catalogs': '/search-mf-freelancers-catalogs',
    'project-proposal-mf-top-summaries': '/project-proposal-mf-top-summaries',
    'search-mf-entrypoint': '/search-mf-entrypoint',
    'financing-mf-invoice-financing-admin': '/financing-mf-invoice-financing-admin',
    'payment-mf-freelancer-bank-account': '/payment-mf-freelancer-bank-account',
    'payment-mf-client-legal-entity-wallets': '/payment-mf-client-legal-entity-wallets',
    'brief-mf-details': '/brief-mf-details',
    'brief-mf-application-form': '/brief-mf-application-form',
    'brief-mf-edit': '/brief-mf-edit',
    'compliance-mf-legal-name-autocomplete': '/compliance-mf-legal-name-autocomplete',
    'project-admin-mf-project-admin': '/project-admin-mf-project-admin',
    'compliance-mf-misclassification-guidelines': '/compliance-mf-misclassification-guidelines',
    'sourcing-project-mf-projects-history': '/sourcing-project-mf-projects-history',
    'financing-mf-financing-settings': '/financing-mf-financing-settings',
    'erp-accounting-mf-lot-entries': '/erp-accounting-mf-lot-entries',
    'compliance-mf-additional-billing-profile': '/compliance-mf-additional-billing-profile',
    'compliance-mf-client-identity-manual-verif': '/compliance-mf-client-identity-manual-verif',
    'search-mf-sourcing-search': '/search-mf-sourcing-search',
    'repatriation-opportunity-mf-brief': '/repatriation-opportunity-mf-brief',
    'compliance-mf-team-legal-entities': '/compliance-mf-team-legal-entities',
    // MF_ENDPOINTS ⚓ DON'T TOUCH
};

export const MicroFrontendRootIdMapper: Record<MicroFrontendAvailableApps, `${string}`> = {
    'apptemplate-mf-example': 'apptemplate-mf-example',
    'module-mf-playground': 'module-mf-playground',
    'sourcing-project-mf-decline-freelancer': 'sourcing-project-mf-decline-freelancer',
    'messenger-mf-chatbox': 'messenger-mf-chatbox',
    'punchout-mf-quote-admin': 'punchout-mf-quote-admin',
    'vms-bridge-mf-quote-admin': 'vms-bridge-mf-quote-admin',
    'compliance-mf-business-settings': 'compliance-mf-business-settings',
    'fees-mf-admin': 'fees-mf-admin',
    'compliance-mf-billing-information': 'compliance-mf-billing-information',
    'project-payment-mf-payment-admin': 'project-payment-mf-payment-admin',
    'search-mf-freelancers-catalogs': 'search-mf-freelancers-catalogs',
    'project-proposal-mf-top-summaries': 'project-proposal-mf-top-summaries',
    'search-mf-entrypoint': 'search-mf-entrypoint',
    'financing-mf-invoice-financing-admin': 'financing-mf-invoice-financing-admin',
    'payment-mf-freelancer-bank-account': 'payment-mf-freelancer-bank-account',
    'payment-mf-client-legal-entity-wallets': 'payment-mf-client-legal-entity-wallets',
    'brief-mf-details': 'brief-mf-details',
    'brief-mf-application-form': 'brief-mf-application-form',
    'brief-mf-edit': 'brief-mf-edit',
    'compliance-mf-legal-name-autocomplete': 'compliance-mf-legal-name-autocomplete',
    'project-admin-mf-project-admin': 'project-admin-mf-project-admin',
    'compliance-mf-misclassification-guidelines': 'compliance-mf-misclassification-guidelines',
    'sourcing-project-mf-projects-history': 'sourcing-project-mf-projects-history',
    'financing-mf-financing-settings': 'financing-mf-financing-settings',
    'erp-accounting-mf-lot-entries': 'erp-accounting-mf-lot-entries',
    'compliance-mf-additional-billing-profile': 'compliance-mf-additional-billing-profile',
    'compliance-mf-client-identity-manual-verif': 'compliance-mf-client-identity-manual-verif',
    'search-mf-sourcing-search': 'search-mf-sourcing-search',
    'repatriation-opportunity-mf-brief': 'repatriation-opportunity-mf-brief',
    'compliance-mf-team-legal-entities': 'compliance-mf-team-legal-entities',
    // MF_ROOT_IDS ⚓ DON'T TOUCH
};

export const MicroFrontendBuildAssetsDirMapper: Record<MicroFrontendAvailableApps, `${string}/_nuxt`> = {
    'apptemplate-mf-example': '/apptemplate-mf-example/_nuxt',
    'module-mf-playground': '/module-mf-playground/_nuxt',
    'sourcing-project-mf-decline-freelancer': '/sourcing-project-mf-decline-freelancer/_nuxt',
    'messenger-mf-chatbox': '/messenger-mf-chatbox/_nuxt',
    'punchout-mf-quote-admin': '/punchout-mf-quote-admin/_nuxt',
    'vms-bridge-mf-quote-admin': '/vms-bridge-mf-quote-admin/_nuxt',
    'compliance-mf-business-settings': '/compliance-mf-business-settings/_nuxt',
    'fees-mf-admin': '/fees-mf-admin/_nuxt',
    'compliance-mf-billing-information': '/compliance-mf-billing-information/_nuxt',
    'project-payment-mf-payment-admin': '/project-payment-mf-payment-admin/_nuxt',
    'search-mf-freelancers-catalogs': '/search-mf-freelancers-catalogs/_nuxt',
    'project-proposal-mf-top-summaries': '/project-proposal-mf-top-summaries/_nuxt',
    'search-mf-entrypoint': '/search-mf-entrypoint/_nuxt',
    'financing-mf-invoice-financing-admin': '/financing-mf-invoice-financing-admin/_nuxt',
    'payment-mf-freelancer-bank-account': '/payment-mf-freelancer-bank-account/_nuxt',
    'payment-mf-client-legal-entity-wallets': '/payment-mf-client-legal-entity-wallets/_nuxt',
    'brief-mf-details': '/brief-mf-details/_nuxt',
    'brief-mf-application-form': '/brief-mf-application-form/_nuxt',
    'brief-mf-edit': '/brief-mf-edit/_nuxt',
    'compliance-mf-legal-name-autocomplete': '/compliance-mf-legal-name-autocomplete/_nuxt',
    'project-admin-mf-project-admin': '/project-admin-mf-project-admin/_nuxt',
    'compliance-mf-misclassification-guidelines': '/compliance-mf-misclassification-guidelines/_nuxt',
    'sourcing-project-mf-projects-history': '/sourcing-project-mf-projects-history/_nuxt',
    'financing-mf-financing-settings': '/financing-mf-financing-settings/_nuxt',
    'erp-accounting-mf-lot-entries': '/erp-accounting-mf-lot-entries/_nuxt',
    'compliance-mf-additional-billing-profile': '/compliance-mf-additional-billing-profile/_nuxt',
    'compliance-mf-client-identity-manual-verif': '/compliance-mf-client-identity-manual-verif/_nuxt',
    'search-mf-sourcing-search': '/search-mf-sourcing-search/_nuxt',
    'repatriation-opportunity-mf-brief': '/repatriation-opportunity-mf-brief/_nuxt',
    'compliance-mf-team-legal-entities': '/compliance-mf-team-legal-entities/_nuxt',
    // MF_BUILD_ASSETS_DIRS ⚓ DON'T TOUCH
};
